import { Controller } from "@hotwired/stimulus"
import { Uppy, Dashboard, XHRUpload } from "uppy"

// Connects to data-controller="uppy"
export default class extends Controller {
  static targets = ["input", "preview"]
  static values = { 
    url: String,
    acceptedFileTypes: Array
  }

  connect() {
    this.uppy = new Uppy({
      autoProceed: false,
      restrictions: {
        maxFileSize: 1000000, // 1MB
        allowedFileTypes: this.acceptedFileTypesValue.length > 0 ? this.acceptedFileTypesValue : ['image/*'],
      }
    })

    this.uppy.use(Dashboard, {
      target: this.element,
      inline: true,
      width: 400,
      height: 300,
      proudlyDisplayPoweredByUppy: false
    })

    this.uppy.use(XHRUpload, {
      endpoint: this.urlValue || '/shrine/presign',
      method: 'post',
      formData: true,
      fieldName: 'file'
    })

    this.uppy.on('upload-success', (file, response) => {
      // Handle successful upload
      if (this.hasInputTarget) {
        this.inputTarget.value = JSON.stringify(response.body.data)
      }
      
      if (this.hasPreviewTarget) {
        this.previewTarget.src = response.body.data.url
        this.previewTarget.style.display = 'block'
      }
    })

    this.uppy.on('upload-error', (file, error, response) => {
      console.error('Upload error:', error)
    })
  }

  disconnect() {
    if (this.uppy) {
      this.uppy.destroy()
    }
  }
}
